import * as React from "react";
import {CurrencyManager} from "../../../Utilities/Managers/CurrencyManager";


import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {SwitchContainer} from "shared/core/animation/SwitchContainer";


export class SubFieldPrice extends React.Component<PriceProps, PriceState> {
    static defaultProps: Partial<PriceProps> = {
        Immediate:false
    };

    constructor(props: PriceProps) {
        super(props);
        this.state = {};

    }

    componentDidMount(): void {
        this.props.Model.OnRefresh.Subscribe(this,()=>this.forceUpdate());
    }

    componentWillUnmount(): void {
        this.props.Model.OnRefresh.Unsubscribe(this);
    }

    public render() {
        return(
            <div>
                <SwitchContainer>
                    {!this.props.Model.GetIsValid()?
                        <span className={'rnValidationMessage'}>
                        {this.props.Model.Errors[0].Message}
                    </span>

                        :null}
                </SwitchContainer>
                <SwitchContainer immediate={this.props.Immediate}>
                    {this.ShouldShowPrice()?
                        this.GetPriceContainer():null
                    }
                </SwitchContainer>



            </div>
            )/*
        <SwitchContainer >
            {this.ShouldShowPrice()||!this.props.Model.GetIsValid()?
            <div>





            </div>:null}
        </SwitchContainer>
        )*/
    }

    private ShouldShowPrice(){
        return this.props.Model.calculator!=null&&this.props.Model.calculator.GetIsUsed()&&!this.props.Model.Options.HidePrice;
    }

    public Refresh(){
        this.forceUpdate();
    }

    public GetPriceContainer(){
        if(this.props.Model.calculator.GetIsSale())
            return(
                <div>
                    <span className={"price rn-price "}>
                        <del>
                            <span className={'rn-original-price amount'} dangerouslySetInnerHTML={{__html:CurrencyManager.FormatPrice(this.props.Model.calculator.GetRegularPrice())}}/>
                        </del>
                        <ins style={{marginLeft:5}}>
                             <span className={'amount'} dangerouslySetInnerHTML={{__html:CurrencyManager.FormatPrice(this.props.Model.calculator.GetPrice())}}/>
                        </ins>
                    </span>
                </div>
            )
        return (
            <div>
                <span className={"price rn-price "}>
                    <span className={'amount'} dangerouslySetInnerHTML={{__html:CurrencyManager.FormatPrice(this.props.Model.calculator.GetPrice())}}/>
                </span>
            </div>
        )
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PriceProps {
    Model:FBFieldWithPriceBaseModel;
    Immediate:boolean;
}

interface PriceState {

}

//#endregion "My Region"